import { COLORS } from '@shared/config/colors/colors';
import { styled } from 'goober';

export const SearchWrapper = styled('div')`
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;

    & > :first-child {
        width: 400px !important;
    }

    & .rf-menu {
        width: fit-content !important;
    }
`;

export const FilterContent = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 20px;
    border-top: 1px solid ${COLORS.neutral_10};
`;
